import imgOutside from '../../assets/buildings/skyscraper/outside.jpg';
import imgWaterUpper from '../../assets/buildings/skyscraper/water-upper.jpg';
import imgWaterLower from '../../assets/buildings/skyscraper/water-lower.jpg';
import imgFireProtection from '../../assets/buildings/skyscraper/fire-protection.jpg';
import { BuildingArea } from '../../interfaces/buildings';
import { ProductType } from '../products';
import { TechSector } from '../tech-sector';
import { BuildingType } from '../buildings';
import { SubBuilding } from '../../interfaces/buildings';

const skyscraperConfig: BuildingArea = {
    techSectors: [
        {
            type: TechSector.WATER,
            img: imgWaterLower,
            secondPart: {
                direction: 'Up',
                config: {
                    coordinates: { x: 800, y: 20 },
                    building: BuildingType.SKYSCRAPER_WATER_UPPER,
                    link: `${BuildingType.SKYSCRAPER_WATER_UPPER}/${TechSector.WATER}`
                }
            },
            products: [
                {
                    position: { x: 695, y: 864 },
                    type: ProductType.BOA_COMPACT_EKB,
                },
                {
                    position: { x: 850, y: 910 },
                    type: ProductType.DELTA_MACRO,
                },
                {
                    position: { x: 1156, y: 893 },
                    type: ProductType.SISTO_16_TWA,
                },
            ],
        },
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            products: [
                {
                    position: { x: 950, y: 955 },
                    type: ProductType.ETANORM_FXV,
                },
                {
                    position: { x: 1070, y: 910 },
                    type: ProductType.HYADUO_2_D_FL_COMPACT,
                },
                {
                    position: { x: 1235, y: 1000 },
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR,
                },
            ],
        },
    ],
    img: imgOutside,
};

export const skyscraperWaterUpperConfig: SubBuilding = {
    parentBuilding: BuildingType.SKYSCRAPER,
    img: imgWaterUpper,
    techSectors: [
        {
            type: TechSector.WATER,
        },
    ],
    products: [
        {
            position: { x: 910, y: 530 },
            type: ProductType.DELTA_MACRO,
        },
        {
            position: { x: 1170, y: 592 },
            type: ProductType.SISTO_16_TWA,
        },
        {
            position: { x: 1235, y: 545 },
            type: ProductType.BOA_COMPACT_EKB,
        },
    ],
};

export default skyscraperConfig;